import React from 'react'

export const Graphic = props => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M8.66683 2C9.36976 2 9.94561 2.54392 9.99651 3.23383L10.0002 3.33333V14H6.00016V3.33333C6.00016 2.63043 6.54408 2.05456 7.23399 2.00366L7.3335 2H8.66683ZM13.3335 5.33333C14.0699 5.33333 14.6668 5.93029 14.6668 6.66667V12.6667C14.6668 13.4031 14.0699 14 13.3335 14H11.3335V5.33333H13.3335ZM4.66683 7.33333V14H2.66683C1.93045 14 1.3335 13.4031 1.3335 12.6667V8.66667C1.3335 7.93027 1.93045 7.33333 2.66683 7.33333H4.66683Z'
    />
  </svg>
)